module.exports = __webpack_public_path__ + "static/media/am_inquiry.49934cd7.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/am_inquiry.md
// module id = 1088
// module chunks = 0